if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'false';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
        document.querySelectorAll('[type="submit"]').forEach((button) => button.setAttribute('aria-disabled', true));
        document.querySelectorAll('.cart__checkout-button').forEach((button) => button.setAttribute('disabled', true));

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        let $this = this;
        if (this.cart) {
          let curt_total_price = Number(this.cart.querySelector('.totals__total-value').innerHTML.match(/(-\d+|\d+)(,\d+)*(\.\d+)*/g)[0].replace(/[^0-9]/g, ""));
          curt_total_price = Number(Shopify.formatMoney(curt_total_price, '\{\{amount\}\}'));
          if(this.cart.querySelector('.cart-item.free-product') || curt_total_price < window.cartStrings.cartThresholdFreeSample ){
            fetch('/products/' + this.form.getAttribute('data-handle') + '.js')
              .then(response => response.json())
              .then(product => {
                  this.submitButton.classList.remove('loading');
                  this.submitButton.removeAttribute('aria-disabled');
                  this.querySelector('.loading__spinner').classList.add('hidden');
                if(product.tags.includes("free-sample")){
                  alert('Unable to add free sample to cart.');
                  document.querySelectorAll('.cart__checkout-button').forEach((button) => button.removeAttribute('disabled', true));
                  document.querySelectorAll('[type="submit"]').forEach((button) => button.removeAttribute('aria-disabled', true));
                  return;
                }else{
                  addProduct();
                }
              });
          }else {
            addProduct();
          }
        }

        function addProduct(){
            if(document.querySelector('.pop-up__promo-buyXgetY:not(.hidden)')){
                window.promo_buyXgetY.closePopUp();
                sessionStorage.setItem('gwp', 'close');
            }
          formData.append(
            'sections',
            $this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          $this.cart.setActiveElement(document.activeElement);
          config.body = formData;
          fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              document.querySelectorAll('[type="submit"]').forEach((button) => button.removeAttribute('aria-disabled', true));
              document.querySelectorAll('.cart__checkout-button').forEach((button) => button.removeAttribute('disabled', true));
                if (response.status) {
                    $this.handleErrorMessage(response.description);
                }
              if (window.promo_buyX_getY) {
                    const promoStart = (new Date(window.promo_buyX_getY.dataStart).getTime()) + (window.promo_buyX_getY.timeZone * 60 * 1000);
                    const promoFinish = (new Date(window.promo_buyX_getY.dataEnd).getTime()) + (window.promo_buyX_getY.timeZone * 60 * 1000);
                    const customer_time = (new Date().getTimezoneOffset()) * 60 * 1000 + Date.now();
                    var promo_buyX_getY_in_cart = false;
                    fetch('/cart.json').then(responseCart => responseCart.json())
                        .then(cart => {
                            cart.items.forEach(function (cartItem, i) {
                                if (cartItem.properties && cartItem.properties['_product-type']) {
                                    if (cartItem.properties['_product-type'] == 'gift') {
                                        promo_buyX_getY_in_cart = true;
                                    }
                                }
                            });

                            if (!promo_buyX_getY_in_cart && response.product_id === window.promo_buyX_getY.mainProductTrigger && promoStart < customer_time ) {
                                const sections = $this.cart ? $this.cart.getSectionsToRender().map((section) => section.id) : [];
                                const body = JSON.stringify({
                                    items: [{
                                        id: window.promo_buyX_getY.productGift,
                                        quantity: 1,
                                        properties: {
                                            '_product-type': 'gift'
                                        }
                                    }
                                    ],
                                    sections: sections,
                                    sections_url: window.location.pathname
                                });

                                fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
                                    .then((response) => response.json())
                                    .then((response) => {
                                        $this.cart.renderContents(response);
                                    });
                            }
                        });
                } else if (window.promo_gwp) {
                    const promoStart = (new Date(window.promo_gwp.dataStart).getTime()) + (window.promo_gwp.timeZone * 60 * 1000);
                    const promoFinish = (new Date(window.promo_gwp.dataEnd).getTime()) + (window.promo_gwp.timeZone * 60 * 1000);
                    const customer_time = (new Date().getTimezoneOffset()) * 60 * 1000 + Date.now();
                  let exclude_product = false;
                  if(window.promo_gwp.promoExcludeCollection.length > 0){
                      exclude_product = window.promo_gwp.promoExcludeCollection.find(value => value == response.product_id)
                  }
                  var promo_gwp_in_cart = false;
                  if(!exclude_product){
                      fetch('/cart.json').then(responseCart => responseCart.json())
                          .then(cart => {
                              let cartTotal = cart.total_price / 100;
                              let promo_min_sum = window.promo_gwp.priceTrigger * 1;
                              let popUp_sum = (cartTotal >= promo_min_sum ) ? true : false;
                              cart.items.forEach(function (cartItem, i) {
                                  if (cartItem.properties && cartItem.properties['_product-type']) {
                                      if (cartItem.properties['_product-type'] == 'gift_promo_gwp') {
                                          promo_gwp_in_cart = true;
                                      }
                                  }
                              });

                              if (!promo_gwp_in_cart && popUp_sum && promoStart < customer_time && customer_time < promoFinish) {
                                  console.log('window.promo_gwp1');
                                  const sections = $this.cart ? $this.cart.getSectionsToRender().map((section) => section.id) : [];
                                  const body = JSON.stringify({
                                      items: [{
                                          id: window.promo_gwp.productGift,
                                          quantity: 1,
                                          properties: {
                                              '_product-type': 'gift_promo_gwp'
                                          }
                                      }
                                      ],
                                      sections: sections,
                                      sections_url: window.location.pathname
                                  });

                                  fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
                                      .then((response) => response.json())
                                      .then((response) => {
                                          $this.cart.renderContents(response);
                                      });
                              } else {
                                  $this.cart.renderContents(response);
                              }
                          });
                  }
                } else {
                  $this.cart.renderContents(response);
                }

              if (response.status) {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  errors: response.errors || response.description,
                  message: response.message,
                });
                $this.handleErrorMessage(response.description);



                const soldOutMessage = $this.submitButton.querySelector('.sold-out-message') ? $this.submitButton.querySelector('.sold-out-message') : false;
                if (!soldOutMessage) return;
                $this.submitButton.setAttribute('aria-disabled', true);
                $this.submitButton.querySelector('span').classList.add('hidden');
                soldOutMessage.classList.remove('hidden');
                $this.error = true;
                $this.cart.renderContents(response);
                return;
              } else if (!$this.cart) {
                window.location = window.routes.cart_url;
                return;
              }

              if (!$this.error)
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  cartData: response,
                });
              $this.error = false;
              const quickAddModal = $this.closest('quick-add-modal');
              if (quickAddModal) {
                document.body.addEventListener(
                  'modalClosed',
                  () => {
                    setTimeout(() => {
                      $this.cart.renderContents(response);
                    });
                  },
                  { once: true }
                );
                quickAddModal.hide(true);
              } else {
                $this.cart.renderContents(response);
              }
            })
            .finally(() => {
              $this.submitButton.classList.remove('loading');
              if ($this.cart && $this.cart.classList.contains('is-empty')) $this.cart.classList.remove('is-empty');
              if (!$this.error) $this.submitButton.removeAttribute('aria-disabled');
              $this.querySelector('.loading__spinner').classList.add('hidden');
              document.querySelectorAll('.cart__checkout-button').forEach((button) => button.removeAttribute('disabled', true));
              document.querySelectorAll('[type="submit"]').forEach((button) => button.removeAttribute('aria-disabled', true));
            });
        }

      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
